import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { DialogProvider } from "./components/ConfirmDialog";
import "./index.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./responsive.css";
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <DialogProvider>
      <App />
    </DialogProvider>
  </BrowserRouter>
);


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// A page opened before a deploy may ask for a JS chunk the new deploy removed.
// Reload once to pick up the new build instead of leaving a broken screen.
const isChunkError = (e) => /Loading (CSS )?chunk [\w-]+ failed|ChunkLoadError/i.test(String(e?.message || e?.name || e));
const reloadOnceForChunk = (err) => {
  if (!isChunkError(err)) return;
  try {
    if (sessionStorage.getItem("chunk-reload")) return;
    sessionStorage.setItem("chunk-reload", "1");
  } catch { /* storage blocked — reload anyway */ }
  window.location.reload();
};
window.addEventListener("error", (e) => reloadOnceForChunk(e.error || e));
window.addEventListener("unhandledrejection", (e) => reloadOnceForChunk(e.reason));
window.addEventListener("load", () => { try { sessionStorage.removeItem("chunk-reload"); } catch { /* ignore */ } });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

